import { useHits, useCurrentRefinements, useClearRefinements } from "react-instantsearch-hooks-web"
import FilteredBy from "./FilteredBy"
import SearchedBy from "./SearchedBy"
import { useWorkbenchStore } from "../../store/store"
import { MAX_RELEASE_YEAR, transformClearRefinements } from "./FilterTransforms"
import { useEffect, useState } from "react"
import SortedBy from "./SortedBy"

const AlgoliaResultsCount = () => {
  const [state, setState] = useState(null)
  const {
    results: { nbHits },
  } = useHits()

  useEffect(() => {
    cleanupFunction()
    return () => {
      setState(null)
    }
  }, [])

  const cleanupFunction = () => {
    setState({})
  }

  if (nbHits > 0) {
    return (
      <div className="count-wrapper">
        <span className="count">{nbHits}</span> <span className="count-text">Results</span>
      </div>
    )
  } else {
    return null
  }
}

const WorkbenchFooter = () => {
  const searchQuery = useWorkbenchStore((state) => state.searchQuery)
  const sortedIndexName = useWorkbenchStore((state) => state.sortedIndexName)
  const { items, refine } = useCurrentRefinements({ transformItems: transformClearRefinements })
  const { refine: refineAll } = useClearRefinements()
  const [anyFilters, setAnyFilters] = useState(false)

  useEffect(() => {
    // Algolia's refinement list (items) *may* include a placeholder refinement object for range items (i.e. duration)
    // that includes a prototype item named 'empty' in the refinements array; without refinements, its length is 1.
    let anyFiltersVar = false
    const durationRefinement = items.find((item) => item.attribute === "duration")
    const releaseYearRefinement = items.find((item) => item.attribute === "release_year")
    const minFiltersLimit = !!releaseYearRefinement ? 2 : 1

    if(items.length > minFiltersLimit){
      anyFiltersVar = true
    } else if (
      (!!durationRefinement && !!durationRefinement.refinements[0]) 
      || (!!releaseYearRefinement && !!releaseYearRefinement.refinements.length)
    ) {
      const releaseYearActive = !!releaseYearRefinement
        && releaseYearRefinement.refinements.length > 0
        && (
          //Min is set
          (![0, 1920].includes(releaseYearRefinement.refinements[0]?.value) && releaseYearRefinement.refinements[0]?.operator === ">=")
          //Min is absent but Max is set and at index 0
          || (releaseYearRefinement.refinements[0]?.value < MAX_RELEASE_YEAR && releaseYearRefinement.refinements[0]?.operator === "<=")
          // Max is present and and set below this year
          || (!!releaseYearRefinement.refinements[1] && releaseYearRefinement.refinements[1].value < MAX_RELEASE_YEAR)
        )

      anyFiltersVar = !!durationRefinement 
      && !!durationRefinement.refinements[0] 
      && (!!durationRefinement.refinements[1] 
        || durationRefinement.refinements[0].value != 0 )
      
      anyFiltersVar = anyFiltersVar || releaseYearActive
    } 

    setAnyFilters(prev => {
      // Only update state if the value has actually changed to prevent infinite loops
      if (prev !== anyFiltersVar) {
        return anyFiltersVar
      }
      return prev
    })
  }, [items])

  return (
    <footer>
      <div className="contain browse-summary">
        <div className="group">
          {(anyFilters || searchQuery) && (
            <div className="result-count">
              <AlgoliaResultsCount />
            </div>
          )}
          <div className="vertical-group">
            {(searchQuery || sortedIndexName) && (
              <div className="search-sort-group">
                {searchQuery !== "" && <SearchedBy />}
                {sortedIndexName !== "" && <SortedBy />}
              </div>
            )}
            {!!anyFilters && <FilteredBy items={items} refine={refine} refineAll={refineAll} />}
            
          </div>
        </div>
      </div>
    </footer>
  )
}

export default WorkbenchFooter
